// extracted by mini-css-extract-plugin
export default {"overlay":"DownloadBackground_overlay__XiBE0","delay":"DownloadBackground_delay__Ad398"};